import * as React from "react";
const SvgFfnen = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Öffnen">
    <path
      fill="currentColor"
      d="M114.68 224.33H39.17c-4.14 0-7.5-3.36-7.5-7.5v-75.51c0-4.14 3.36-7.5 7.5-7.5s7.5 3.36 7.5 7.5v68.01h68.01c4.14 0 7.5 3.36 7.5 7.5s-3.36 7.5-7.5 7.5M216.83 122.18c-4.14 0-7.5-3.36-7.5-7.5V46.67h-68.01c-4.14 0-7.5-3.36-7.5-7.5s3.36-7.5 7.5-7.5h75.51c4.14 0 7.5 3.36 7.5 7.5v75.51c0 4.14-3.36 7.5-7.5 7.5"
    />
  </svg>
);
export default SvgFfnen;
